import React from 'react';
import PropTypes from 'prop-types';

import { StyledButton, StyledIcon } from './styled';

const Button = ({ label, onClick, width, type, isLoading }) => {
    return (
        <StyledButton onClick={onClick} width={width} type={type} isLoading={isLoading}>
            {isLoading ? <StyledIcon name="autorenew" /> : label}
        </StyledButton>
    );
};

Button.defaultProps = {
    type: 'button',
    width: 'auto',
    onClick: undefined,
    isLoading: false,
};

Button.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    type: PropTypes.string,
    width: PropTypes.string,
    isLoading: PropTypes.bool,
};

export default Button;
